module.exports = __webpack_public_path__ + "static/media/item_29_7.985654f8.png";